import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Card, Button, ButtonGroup, Dropdown, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import Divider from "@material-ui/core/Divider";
import ToolkitProvider, {
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import paginationFactory from "react-bootstrap-table2-paginator";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
// import "../../Utils/Css/Marketing.css";
// import "../../Utils/Css/Campagne.css";
import clientService from "./../../../services/MarketingService/ClientService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

function PageClient() {
  //data

  const [data, setData] = useState([]);
  const [genresData, setGenresData] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [success, setSuccess] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const [fileName, setFileName] = useState("");
  const [filter, setFilter] = useState({
    nom: "",
    startDate: "",
    endDate: "",
  });
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    genre: "",
    age: "",
    ville: "",
    rue: "",
    pays: "",
    email: "",
  });
  useEffect(() => {
    AfficherListGenres();
    fetchData();
  }, []);

  //methode pour afficher genres
  const AfficherListGenres = () => {
    try {
      clientService.AfficherListGenres().then((response) => {
        setGenresData(response.data.success);
      });
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  // Gérer les changements de valeur dans l'entrée
  const handleInputChangeImport = (event) => {
    setInputValue(event.target.value);

    // Désactiver le bouton de suppression si l'entrée est vide ou différente de "DELETE"
    if (event.target.value !== "IMPORTER") {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  };

  // Gérer les changements de valeur dans l'entrée
  const handleInputChangeDelete = (event) => {
    setInputValue(event.target.value);

    // Désactiver le bouton de suppression si l'entrée est vide ou différente de "DELETE"
    if (event.target.value !== "DELETE") {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  };

  //edit data
  const handleEditClient = (Client) => {
    setSelectedClient(Client);
    setShowModal(true);
    setFormData({
      firstName: Client.firstName,
      lastName: Client.lastName,
      genre: Client.genre,
      phoneNumber: Client.phoneNumber,
      age: Client.age,
      ville: Client.ville,
      rue: Client.rue,
      pays: Client.pays,
      email: Client.email,
    });
  };
  const handleUpdateClient = async (event) => {
    event.preventDefault();

    const {
      firstName,
      lastName,
      genre,
      phoneNumber,
      age,
      ville,
      rue,
      pays,
      email,
    } = formData;

    if (
      firstName === selectedClient.firstName &&
      lastName === selectedClient.lastName &&
      genre === selectedClient.genre &&
      phoneNumber === selectedClient.phoneNumber &&
      age === selectedClient.age &&
      ville === selectedClient.ville &&
      rue === selectedClient.rue &&
      pays === selectedClient.pays &&
      email === selectedClient.email
    ) {
      // Vérifier si les champs ont été modifiés
      setErreur(
        "Veuillez modifier au moins un champ avant de soumettre le formulaire."
      );
      return;
    }

    const updatedClient = formData;
    if (!firstName || !lastName) {
      // Vérifier si le firstName et le préfirstName sont renseignés
      setErreur("Veuillez renseigner tous les champs.");
      return;
    }

    clientService
      .mettreAJourClient(updatedClient, selectedClient.id)
      .then(() => {
        const updatedData = data.map((Client) =>
          Client.id === selectedClient.id
            ? { ...Client, ...updatedClient }
            : Client
        );
        setData(updatedData);
        setShowModal(false);
        setSelectedClient(null);
        setSuccess("Modification validée avec succès !");
      });
  };

  const fetchData = () => {
    try {
      clientService.AfficherListClients(getCurrentUserId()).then((response) => {
        setData(response.data.success);
      });
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  //importCSVFile
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile.name);
  };

  const handleImport = async () => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await clientService.ImporterCSV(formData);
      console.log(response.data); // handle successful response
    } catch (error) {
      console.log(error); // handle error
    }
  };
  //export data

  const handleExportCSV = async () => {
    try {
      const response = await clientService.Exportcsv();
      // Create a URL for the blob object containing the CSV data
      const csvData = window.URL.createObjectURL(new Blob([response.data]));
      // Create a link element and click it to start the download
      const link = document.createElement("a");
      link.href = csvData;
      link.download = "Clients.csv";
      link.click();
    } catch (error) {
      console.log(error); // handle error
    }
  };

  // update filter parameters on change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //filtre par date

  // cancel date range filter
  const handleCancelDateRange = () => {
    setFilter((prevState) => ({
      ...prevState,
      startDate: "",
      endDate: "",
    }));
  };
  // update filter on date range change
  const handleDateRangeChange = (event, picker) => {
    setFilter((prevState) => ({
      ...prevState,
      startDate: picker.startDate.format("YYYY-MM-DD"),
      endDate: picker.endDate.format("YYYY-MM-DD"),
    }));
  };

  // filter data
  const filterData = async () => {
    // try {
    //   const response = await clientService.getClientsByFiltre(
    //     filter.nom,
    //     filter.startDate,
    //     filter.endDate
    //   );
    //   setData(response.data);
    //   //console.log(response.data);
    // } catch (error) {
    //   console.log(error);
    //   setErreur(error.message);
    // }
  };

  // useEffect to fetch data based on filter parameters
  useEffect(() => {
    filterData();
  }, [filter]);

  const handleModify = async () => {
    try {
      // Appeler la fonction handleImport
      await handleImport();

      // Appeler la fonction fetchData pour rafraîchir les données
      await fetchData();
      setShowImportcsvmodal(false);
      setInputValue("");
      setFileName("");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (success) {
      const timeoutId = setTimeout(() => {
        setSuccess(null);
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
    if (erreur) {
      const timeoutId = setTimeout(() => {
        setErreur(null);
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
  }, [success, erreur]);

  const handleCancel = () => {
    setShowModal(false);
    setSelectedClient(null);
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  //importer csv
  const [showImportcsvmodal, setShowImportcsvmodal] = useState(false);
  const handleImporterFichierCSVModal = () => {
    setShowImportcsvmodal(true);
  };
  const handleCancelImportcsvmodal = () => setShowImportcsvmodal(false);

  //DeleteModal
  const [show, setShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleClose = () => setShow(false);

  const handleDeleteClient = (row) => {
    setSelectedRow(row);
    setShow(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await clientService.supprimerClient(selectedRow.id);
      const newData = data.filter((item) => item.id !== selectedRow.id);
      setData(newData);
      setShow(false);
      // Effacer la valeur de l'input "DELETE" après le clique sur le button supprimer
      setInputValue("");
    } catch (error) {
      console.error(error);
    }
  };
  //end of DeleteModal
  // /.end of data

  //pagination
  const paginationOptions = {
    sizePerPage: 4,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  const options = {
    sizePerPage: 4,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    ...paginationOptions,
  };

  //Date

  //CSVExport
  const { ExportCSVButton } = CSVExport;

  // columns-Client
  const columns = [
    {
      dataField: "creationDate",
      text: "Date creation",
      formatter: (cell) => {
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const date = new Date(cell);
        return date.toLocaleDateString("fr-FR", options).replace(/\//g, "-");
      },
    },
    {
      dataField: "firstName",
      text: "Prenom",
    },
    {
      dataField: "lastName",
      text: "Nom",
    },
    {
      dataField: "genre",
      text: "Genre",
    },

    {
      dataField: "age",
      text: "Age",
    },
    {
      dataField: "ville",
      text: "Ville",
    },
    {
      dataField: "rue",
      text: "Rue",
    },
    {
      dataField: "pays",
      text: "Pays",
    },
    {
      dataField: "actions",
      text: "Actions",
      csvExport: false,
      formatter: (cellContent, row) => {
        return (
          <>
            <div className="d-flex justify-content-center">
              <Button
                variant="secondary"
                className="mr-2"
                onClick={() => handleEditClient(row)}
              >
                <i className="fas fa-edit"></i>
              </Button>
              <Button
                variant="dark"
                className="mr-2"
                onClick={() => handleDeleteClient(row)}
              >
                <i className="fas fa-trash"></i>
              </Button>
            </div>
          </>
        );
      },
    },
  ];
  // /.columns-Client
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Client</h1>
            </div>
            <div className="col-sm-6"></div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row mt-2">
            <div className="col-md-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div className="row">
                    <div className="col">
                      <label>Date</label>
                      <div className="input-group date mt-2">
                        <DateRangePicker
                          className="input-group date"
                          startDatePlaceholder="Start Date"
                          endDatePlaceholder="End Date"
                          onApply={handleDateRangeChange}
                        >
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <FontAwesomeIcon icon={faCalendarAlt} />
                              </span>
                            </div>
                            <input
                              type="text"
                              className="form-control datetimepicker-input"
                              placeholder="Select Date .."
                              value={
                                filter.startDate && filter.endDate
                                  ? `${filter.startDate} - ${filter.endDate}`
                                  : ""
                              }
                            />
                            {filter.startDate && filter.endDate && (
                              <div className="input-group-append">
                                <span className="input-group-text">
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    onClick={handleCancelDateRange}
                                  />
                                </span>
                              </div>
                            )}
                          </div>
                        </DateRangePicker>
                      </div>
                    </div>
                    {/* Button-ajouter*/}
                    <div className="col col-lg-2">
                      <label>Ajouter</label>
                      <div className="d-grid gap-2 mt-2">
                        <Dropdown as={ButtonGroup} style={{ width: "100%" }}>
                          <Button
                            variant="secondary"
                            className="my-custom-class Ajouter"
                          >
                            Ajouter
                          </Button>
                          <Dropdown.Toggle
                            split
                            variant="secondary"
                            className="my-custom-class Ajouter"
                            id="dropdown-split-basic"
                          />
                          <Dropdown.Menu>
                            <Link
                              to="/Client/AddClient"
                              className="dropdown-item"
                            >
                              Ajouter Client
                            </Link>
                            <Dropdown.Item
                              onClick={() => handleImporterFichierCSVModal()}
                            >
                              Importer CSV
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {success && (
            <div className="alert alert-success" role="alert">
              {success}
            </div>
          )}

          {/* /.ImporterFichiercsvModal */}
        </div>

        {/* /.container-fluid */}
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row mt-2">
            <div className="col-md-12">
              <div class="card card-dark">
                <div class="card-body">
                  <ToolkitProvider>
                    {(props) => (
                      <>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div className="d-flex justify-content-end align-items-center mb-2">
                              <div className="input-container">
                                {/* SearchData */}
                                <div className="p-2">
                                  <div className="input-group">
                                    <input
                                      className="form-control "
                                      type="search"
                                      placeholder="Search"
                                      aria-label="Search"
                                      name="nom"
                                      value={filter.nom}
                                      onChange={handleFilterChange}
                                    />
                                  </div>
                                </div>
                                {/* /.SearchData */}
                                {/* ExportCSV button */}
                                <div className="p-2">
                                  <Button
                                    onClick={handleExportCSV}
                                    variant="dark"
                                    className="my-custom-class Exporter input-container"
                                  >
                                    Exporter CSV
                                  </Button>
                                </div>
                                {/* /.ExportCSV button */}
                              </div>
                            </div>
                            <div className="table-container thead-dark mb-3">
                              <BootstrapTable
                                keyField="id"
                                hover
                                condensed
                                pagination={paginationFactory(options)}
                                defaultSorted={[
                                  { dataField: "creationDate", order: "asc" },
                                ]}
                                faultSortDirection="asc"
                                noDataIndication={() => "No data found"}
                                data={data}
                                columns={columns}
                                headerClasses="thead-dark"
                                search
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </ToolkitProvider>
                  <Modal
                    show={showModal}
                    onHide={handleCancel}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <div
                      className="card card-dark"
                      style={{ boxShadow: "none", marginBottom: 0 }}
                    >
                      <div className="card-header">
                        <h3 className="card-title">Modifier Client</h3>
                        <button className="close">
                          <FontAwesomeIcon
                            icon={faTimes}
                            closeButton
                            onClick={handleCancel}
                            style={{ color: "white" }}
                          />
                        </button>
                      </div>
                      <form>
                        <div className="card-body">
                          {erreur && (
                            <div className="alert alert-danger" role="alert">
                              {erreur}
                            </div>
                          )}

                          <div className="form-group">
                            <div className="row">
                              <div className="col">
                                <label htmlFor="firstName">Prenom </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="firstName"
                                  placeholder="firstName"
                                  name="firstName"
                                  value={formData.firstName}
                                  onChange={handleInputChange}
                                />
                              </div>
                              <div className="col">
                                <label htmlFor="lastName">Nom</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="lastName"
                                  placeholder="lastName"
                                  name="lastName"
                                  value={formData.lastName}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <div className="row">
                              <div className="col">
                                <label htmlFor="firstName">Genre </label>
                                <select
                                  className="custom-select"
                                  id="genre"
                                  name="genre"
                                  value={formData.genre}
                                  onChange={handleInputChange}
                                >
                                  {genresData.map((genre) => (
                                    <option key={genre} value={genre}>
                                      {genre}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col">
                                <label htmlFor="lastName">Email</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="Email"
                                  placeholder="Email"
                                  name="email"
                                  value={formData.email}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <div className="row">
                              <div className="col">
                                <label htmlFor="exampleInputEmail1">
                                  numero
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="exampleInputEmail1"
                                  placeholder="phoneNumber"
                                  name="phoneNumber"
                                  value={formData.phoneNumber}
                                  onChange={handleInputChange}
                                />
                              </div>
                              <div className="col">
                                <label htmlFor="exampleInputEmail1">Age</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="exampleInputEmail1"
                                  placeholder="Age"
                                  name="age"
                                  value={formData.age}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Adresse</label>
                            <div className="row">
                              <div className="col">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="exampleInputEmail1"
                                  placeholder="Rue"
                                  name="rue"
                                  value={formData.rue}
                                  onChange={handleInputChange}
                                />
                              </div>
                              <div className="col">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="exampleInputEmail1"
                                  placeholder="Ville"
                                  name="ville"
                                  value={formData.ville}
                                  onChange={handleInputChange}
                                />
                              </div>
                              <div className="col">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="exampleInputEmail1"
                                  placeholder="pays"
                                  name="pays"
                                  value={formData.pays}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-footer text-right">
                          <button
                            type="button"
                            className="btn btn-secondary mr-2"
                            onClick={handleCancel}
                          >
                            Annuler
                          </button>
                          <button
                            type="submit"
                            className="btn btn-dark"
                            onClick={handleUpdateClient}
                          >
                            Modifier
                          </button>
                        </div>
                      </form>
                    </div>
                  </Modal>
                  {/* /.EditEventModal */}
                  {/* DeleteModal */}
                  <Modal show={show} onHide={handleClose} centered>
                    <Modal.Header>
                      <Modal.Title>Confirmation de suppression</Modal.Title>
                      <button className="close">
                        <FontAwesomeIcon
                          icon={faTimes}
                          closeButton
                          onClick={handleClose}
                        />
                      </button>
                    </Modal.Header>
                    <Modal.Body>
                      Êtes-vous sûr(e) de vouloir supprimer ?<br />
                      <br />
                      <strong>Date de creation : </strong>
                      {selectedRow && selectedRow.createdDate && (
                        <>
                          {new Date(selectedRow.createdDate)
                            .toLocaleDateString("fr-FR", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            })
                            .replace(/\//g, "-")}
                        </>
                      )}
                      <br />
                      <strong>firstName : </strong>
                      {selectedRow && selectedRow.firstName}
                      <br />
                      <strong>lastName : </strong>
                      {selectedRow && selectedRow.lastName}
                      <br />
                      <br />
                      <p>
                        Tapper le mot <strong>DELETE</strong> pour pouvez
                        supprimer Data
                      </p>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="DELETE"
                        value={inputValue}
                        onChange={handleInputChangeDelete}
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        Annuler
                      </Button>
                      <Button
                        variant="danger"
                        onClick={handleConfirmDelete}
                        disabled={buttonDisabled}
                      >
                        Supprimer
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  {/* /.DeleteModal */}

                  {/* ImporterFichiercsvModal */}
                  <Modal
                    show={showImportcsvmodal}
                    onHide={handleCancelImportcsvmodal}
                    centered
                  >
                    <Modal.Header>
                      <Modal.Title>Confirmation de l'importation</Modal.Title>
                      <button className="close">
                        <FontAwesomeIcon
                          icon={faTimes}
                          closeButton
                          onClick={handleCancelImportcsvmodal}
                        />
                      </button>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="custom-file mb-3">
                        <input
                          type="file"
                          className="custom-file-input"
                          onChange={handleFileChange}
                        />
                        <label
                          className="custom-file-label"
                          htmlFor="customFile"
                        >
                          {fileName || "Choose file"}
                        </label>
                      </div>
                      <p>
                        Tapper le mot <strong>IMPORTER</strong> pour pouvez
                        importer le fichier CSV
                      </p>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="IMPORTER"
                        value={inputValue}
                        onChange={handleInputChangeImport}
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={handleCancelImportcsvmodal}
                      >
                        Annuler
                      </Button>
                      <Button
                        variant="warning"
                        onClick={handleModify}
                        disabled={buttonDisabled}
                      >
                        Importer
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>{" "}
              </div>{" "}
            </div>
          </div>
        </div>
      </section>
      {/* /.content */}
    </div>
  );
}

export default PageClient;
